/** Blank draft is zero. A typed 0 stays visible so the next digit can build on it. */
export function consumeQuantityFromDraft(draft: string): number {
  if (draft.trim() === "") return 0;
  const parsed = Number.parseInt(draft, 10);
  return Number.isFinite(parsed) ? parsed : 0;
}

/** Keystrokes keep a manually typed 0. Clearing the field stays blank. */
export function draftConsumeQuantityFromKeystrokes(raw: string, maximum: number): string {
  const digits = raw.replace(/\D/g, "");
  if (digits === "") return "";
  const parsed = Number.parseInt(digits, 10);
  if (!Number.isFinite(parsed)) return "";
  if (parsed > maximum) return String(maximum);
  return String(parsed);
}

/**
 * Stepper that lands on zero clears the field. The operator can then type 5
 * without the leftover 0 turning it into 50.
 */
export function stepConsumeQuantityDraft(current: string, delta: number, maximum: number): string {
  const next = consumeQuantityFromDraft(current) + delta;
  if (next <= 0) return "";
  if (next > maximum) return String(maximum);
  return String(next);
}
